export { AcceptPasswordInputComponent } from './accept-password-input.component';
